var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({key:(_vm.to + "-" + _vm.gameId),attrs:{"to":_vm.calculatedTo}},'router-link',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }